<template>
	<simple-modal
		@close="close()"
		:display="display"
		:alerts="alerts"
		:title="title"
	>
		<template #default>
			<div>
				<div class="columns">
					<div class="column">
						<div class="columns">
							<div class="column">
								<div class="control is-fullwidth" v-for="type in addressTypes">
									<label class="checkbox"  :for="type.id">
										<input type="checkbox" :id="type.id" :value="type.id" v-model="formAddress.address_type_id">
										{{ type.name }}
									</label>
								</div>
							</div>
						</div>
						<div class="columns" v-if="entityType === 'Customer'">
							<div class="column is-fullwidth">
								<input
									class="input"
									type="text"
									:placeholder="translation.contact_long"
									v-model="formAddress.contact"
								>
							</div>
						</div>
						<div class="columns">
							<div class="column is-three-fifths">
								<input
									class="input"
									type="text"
									:placeholder="translation.street"
									v-model="formAddress.street"
								>
							</div>
							<div class="column">
								<input
									class="input"
									type="text"
									:placeholder="translation.number"
									v-model="formAddress.number"
								>
							</div>
							<div class="column">
								<input
									class="input"
									type="text"
									:placeholder="translation.box"
									v-model="formAddress.box"
								>
							</div>
						</div>
						<div class="columns">
							<div class="column is-two-fifths">
								<input
									class="input"
									type="text"
									:placeholder="translation.postal_code"
									v-model="formAddress.zip_code"
								>
							</div>
							<div class="column">
								<input
									class="input"
									type="text"
									:placeholder="translation.city"
									v-model="formAddress.city"
								>
							</div>
						</div>
						<div class="columns">
							<div class="column">
								<div class="control has-icons-left is-fullwidth">
									<div class="select is-fullwidth">
										<select v-model="formAddress.country_id">
											<option v-for="country in countries" :value="country.country_id" :key="country.country_id">{{ country.name }}</option>
										</select>
									</div>
									<span class="icon is-left">
										<i class="fa-solid fa-globe"></i>
									</span>
								</div>
							</div>
						</div>
					</div>
				</div>

			</div>
		</template>
		<template #footer>
			<button
				class="button is-fullwidth is-danger"
				@click="doDeleteAddress()"
				:disabled="!canDeleteAddress"
			>
				{{ translation.delete }}
			</button>
			<button class="button is-fullwidth" @click="close()">
				{{ translation.cancel }}
			</button>
			<button
				class="button is-fullwidth is-success track-action"
				@click="doSaveAddress()"
				:disabled="!canSaveAddress"
				:class="{'is-loading' : formAddress.loading}"
				data-ta-event="clientarea-track.company.addresses.add-address.save"
				data-ta-action="Click"
				data-ta-label="Company-page – Addresses – Save address on New address modal"
				data-ta-page-name="MyCompanyPage"
			>
				{{ translation.save }}
			</button>
		</template>
	</simple-modal>
</template>

<script>
import {ApiMonizze, LoaderState} from '../api-monizze';

export default {
	data: function()
	{
		return {
			countries: [],
			canDeleteAddress: false,
			alerts: null,
			title: this.$props.translation.add_title,
			formAddress : {
				id : null,
				address_type_id : [],
				country_id : this.$props.countryCode,
				city : '',
				zip_code : '',
				number : '',
				street : '',
				box : '',
				loading: false
			},
		};
	},
	props: {
		addressTypes: {
			type: Array,
			required: false
		},
		display: {
			type: Boolean,
			default: false,
		},
		address: {
			type: Object,
			required: false
		},
		urls:{
			type: Object,
			required: false
		},
		translation : {
			type: Object,
			required: false
		},
		entityType : {
			type: String,
			required : true
		},
		entityId : {
			type: Number,
			required: true
		},
		logUrl: {
			type: String,
			required: true
		},
		countryCode: {
			type: Number,
			required: true,
			default: 1
		}
	},
	created() {
		this.loadCountries();

	},
	updated() {
		if (this.address !== null)
		{
			this.formAddress = {
				id : this.$props.address.id,
				address_type_id : this.$props.address.address_type_id_all,
				country_id : this.$props.address.country_id,
				city : this.$props.address.city,
				zip_code : this.$props.address.zip_code,
				number : this.$props.address.number,
				street : this.$props.address.street,
				box : this.$props.address.box,
				contact : this.$props.address.contact,
				loading: false
			};
			this.canDeleteAddress = this.$props.urls.delete !== '';
			this.title = this.$props.translation.edit_title;
		}
		else
		{
			this.formAddress = {
				id : null,
				address_type_id :  this.$props.addressTypes.length === 1 ? this.$props.addressTypes : [],
				country_id : this.$props.countryCode,
				city : '',
				zip_code : '',
				number : '',
				street : '',
				box : '',
				contact : '',
				loading: false
			};
			this.canDeleteAddress = false;
			this.title = this.$props.translation.add_title;
		}
	},
	computed: {
		canSaveAddress: function()
		{
			return this.formAddress.street
				&& this.formAddress.number
				&& this.formAddress.zip_code
				&& this.formAddress.city
				&& this.formAddress.country_id
				&& this.formAddress.address_type_id.length > 0
		},
	},
	methods: {
		loadCountries: function()
		{
			new ApiMonizze()
				.getDataFromApi(
					this.$props.urls.country,
					(data) => this.countries = data
				);
		},
		close: function()
		{
			this.$emit('close');
		},
		doSaveAddress: function()
		{
			(new ApiMonizze(new LoaderState(this.formAddress)))
				.loadData(
					{
						url: this.$props.urls.save,
						method: 'post',
						data: this.formAddress
					},
					(data, response) => {
						this.$emit('save');
					}
				);

		},
		doDeleteAddress: function()
		{
			if(!confirm(this.$props.translation.confirm_delete_address))
			{
				return;
			}
			axios
				.delete(this.$props.urls.delete.replace(':addressId:', this.formAddress.id))
				.then(() => {
					addFlashAlert('success', this.$props.translation.address_delete_ok);
				})
				.finally( () =>
				{
					this.close();
				});
		},
	},
}
</script>
